pyzel.surfboard_details = {

	init: function( id ){

		//alert( id );
		//console.log('get details for board: '+id);

		// get models
		$.get({

			url: endpoint+'/surfboardmodels/'+id+'/build',
			//method: 'get'

		}).done( r => {		

			r = r[0];

			//console.log( r );

			$('.model-name').text( r.surfboardmodel );
			$('#model-logo').prop('src', r.img_logo );
			$('#model-price').text( r.min_price );

			// get first p element, or get from API?
			// here the text does not bring paragraphs from the start..
			
			//let intro_text = $( r.description ).filter('p:first').text();

			//let intro_text = $( r.description ).filter('p:first').text();
			//let intro_text = $("<textarea/>").html(r.description).html();//$( r.description ).filter('p:first').text();
			//let body_text = r.description.replace( intro_text, '' );

			// improv. intro and body as they are not served from API
			// nor have standard formating, ie: paragraphs
			let bio_intro = r.description.split('.');

			$('#model-description-intro').html( bio_intro[0]+'.' );
			$('#model-description-body').html( r.description.replace( bio_intro[0]+'.' , '' ) );

			//$('#model-description-intro').text( intro_text );
			//$('#model-description-body').html( body_text );							
			

			//$('#model-description-intro').html( r.description );
			$('#model-category').text( r.surfboardmodeltype );
			$('#breadcrumb-surfboard-category').prop('href', '?page=surfboards#'+pyzel.helpers.safe_name( r.surfboardmodeltype ) ).text( r.surfboardmodeltype );			

			$('#model-wave-size').text( r.wavesize.min+'-'+r.wavesize.max + r.wavesize.measure );
			$('#model-skill-level').text( pyzel.helpers.skill_level( r.skilllevel ) );

			let board_features = pyzel.helpers.board_features( r.features );

			//console.log( board_features );

			$('#model-tails').text( board_features['tail'] );
			$('#model-rails').text( board_features['rails'] );
			
			$('#model-fins').text( pyzel.helpers.csv( r.finsystem ) );
			$('#model-fins-setup').text( pyzel.helpers.csv( r.fin_setup ) );
			
			//$('#model-technology').text( pyzel.helpers.csv( r.technology ) );
			$('#model-technology').text( pyzel.helpers.csv( r.construction_type, 'constructiontype' ) );
			
			$('#model-sprays').text( pyzel.helpers.csv( r.paint ) );

			$('#wave-height-graphic-min-size').text( r.wavesize.min );
			$('#wave-height-graphic-max-size').text( r.wavesize.max );
			$('.wave-height-graphic-measure').text( r.wavesize.measure );

            $.each( r.skilllevel, ( k, i ) => {

            	//console.log( k );
            	//console.log( i );

            	//console.log( $('.skill-level-'+k) );

                $('.skill-level-'+k).addClass('skill-level-selected');

            }) 			

			//console.log( pyzel.helpers.csv( r.technology ) );

			pyzel.social.init();

			//------------------------------------------------------------------
			// custom order and shop links - TOP OF THE PAGE
			// THE BIG BUTTONS ARE DEFAULT - no specs, just the model..					

			$('#custom-order-link').prop( 'href','/custom-order?model='+id );			
			// so much for pretty urls..
			$('#shop-link').prop('href','?page=shopsurfboard&model='+id );			

			//------------------------------------------------------------------
			// board slider

			let slider_html = '';

			//console.log( r.img );

			$.each( r.img, ( k ,i ) => {

				//console.log( k );

				if( i.cover == 1 )
					$('#pinterest-img').data('img', i.img_dynamic ).data('txt', r.surfboardmodel +' - '+r.surfboardmodeltype  );

				slider_html +=

				`<div class="slide">

					<img src="${ i.img_dynamic }" width="1050" height="1050" alt="Pyzel surfboard details">

				</div>`;			

			})// end each		

			let table_html = '';
			let action_btn = '';

			$.each( r.standard_dimensions, ( k , i ) => {

				//console.log( k );
				//console.log( i );

				let model_specs = 'model='+id+'&length='+i.length+'&width='+i.width+'&thickness='+i.thickness;

				if( i.currentavailability == 1 ){

					action_btn = `
						<a href="?page=shopsurfboard&${ model_specs }" class="btn btn-black btn-full">Buy now</a>
						<a href="?page=shopsurfboard&${ model_specs }" class="round-btn cart"></a>`;

				}else{

					action_btn = `
						<a href="/custom-order?${ model_specs }" class="btn btn-primary btn-full">Custom order</a>
						<a href="/custom-order?${ model_specs }" class="round-btn custom"></a>`;

				}

				table_html += 

				`<tr>
					
					<td>
						${ i.length_inches }
					</td>

					<td>
						${ i.width_inches }
					</td>

					<td>
						${ i.thickness_inches }
					</td>

					<td>
						${ i.volume }L
					</td>

					<td class="actions">
						${ action_btn }
					</td>

				<tr>`;			

			})

			$('#model-standard-dimensions tbody').append( table_html );

			//pyzel.helpers.get_video_details( r.videos );

			//------------------------------------------------------------------
			// videos - maybe a function?

			let videos_html = '';

			//console.log('videos length:');
			//console.log( r.videos.length );

			let vimeo_videos_total = 0;

			let loops = 0;

			$.each( r.videos, ( k ,i ) => {

				//console.log( i );
				//console.log( k );

				//let video_details = pyzel.helpers.get_video_details( i );

				//pyzel.helpers.get_video_details( i ).then( function( r ){});

				/*
				pyzel.helpers.get_video_details_test( i ).then( function( r ){

					console.log( 'response of deferred:' );
					console.log( r );

				});
				*/
							
				//pyzel.helpers.get_video_details( i ).then( function( r ){
				//$.when( pyzel.helpers.get_video_details( i ) ).then( function( r ){
				//pyzel.helpers.get_video_details( i ).then( function( r ){

				// parse id - make a function?
				// it should also detect if is vimeo or youtubiu
				// the site was done only to handle vimeo

				let url_parts = i.url.split('/');				

				if( url_parts[2] != 'vimeo.com' ){

					console.log( i.url+' - sorry, vimeo videos only!');
					return 0;

				}else{

					vimeo_videos_total ++;	

				}

				let video_id = url_parts[ url_parts.length - 1 ];
				//console.log( id );

				if( isNaN( video_id ) ){

					console.log( 'invalid video id: '+video_id );
					return 0;

				}

				pyzel.vimeo.get_image( video_id ).then( function( img ){

					loops ++;

					let video_img = img.data[0].sizes[ img.data[0].sizes.length -1 ].link;				

					videos_html = `

					<div class="slide">
						<a href="#" data-vimeo-id="${ video_id }" class="js-fullwidth-video-play">
							<div class="image" style="background-image: url('${ video_img }')"></div>
							<div class="play">
								<img src="/images/play-circle.svg" width="230" height="230" class="play-circle" alt="Play">
							</div>
						</a>
					</div>`;

					$('#model-videos-placeholder').append( videos_html );

					console.log( k );

					//if( r.videos.length - 1 == k ){
					if( vimeo_videos_total == loops ){

						console.log('videos length equal current video.');
						pyzel.convertToSVG();
						pyzel.fullwidthVideo.init();
						pyzel.sliders.fullwidthVideo();
						//pyzel.fullwidthVideo.init();

					}

				});

				//$('#model-videos-placeholder').append( videos_html );
				
				//pyzel.sliders.fullwidthVideo();			
				//pyzel.fullwidthVideo.init();

			})													

			//------------------------------------------------------------------
			// other models - should load with lazy load..

			let other_models_html = '';

			$.each( r.other_models, ( k, i ) => {

				//console.log( i );

				other_models_html += `
					
					<a href="index.php?page=surfboard-details&id=${ i.id_surfboardmodel }" class="slide surfboard-listing-single">

						<div class="name">
							${ i.surfboardmodel }
						</div>
						
						<div class="price">

							${ i.min_price } EUR

						</div>

						<img src="${ i.img_dynamic }?w=700" width="340" height="425" alt="${ i.surfboardmodel }">

						<div class="category">
							
							${ i.surfboardmodeltype }

						</div>

						<div class="specs">

							${ i.wavesize.min }-${ i.wavesize.max }${ i.wavesize.measure } 

						</div>

						<div class="btn btn-primary btn-sm">See more</div>

					</a>`;

			})

			let el = $('#other-boards-placeholder');

			el.html( other_models_html );

			el.slick({
				slidesToShow: 4,
				slidesToScroll: 4,
				arrows: false,
				dots: true,
				dotsClass: 'slider-pager',
				autoplay: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});

			$('#model-slider').html( slider_html );

			//------------------------------------------------------------------

			//pyzel.convertToSVG();
			pyzel.sliders.surfboardDetails();
			//pyzel.sliders.fullwidthVideo();			
			//pyzel.fullwidthVideo.init();

		})// end ajax done

	}

}